import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import HistorialEstados from './pages/HistorialEstados';

function PrivateRoute({ children }) {
  const { usuario, loading } = useAuth();
  if (loading) return (
    <div style={{
      minHeight:'100vh', background:'#f8f9fa',
      display:'flex', alignItems:'center', justifyContent:'center',
      color:'#6b6b6b', fontFamily:'Inter,sans-serif', fontSize:'13px'
    }}>
      Cargando...
    </div>
  );
  return usuario ? children : <Navigate to="/login" />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          } />
          <Route path="/estados" element={
            <PrivateRoute>
              <HistorialEstados />
            </PrivateRoute>
          } />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
